export const equipmentRequestStatus: any = {
  DRAFT: 'Черновик',
  NEW: 'Создан',
  IN_PROGRESS: 'В работе',
  NEED_INFO: 'Уточнение',
  COMPLETED: 'Выполнен',
  CLOSED: 'Закрыт',
  DELETED: 'Удален',
};
